import React from 'react'
import { css } from 'aphrodite'
import { Row, Col, Container } from 'reactstrap'
import { Link } from 'react-router-dom'

import style from './style'

const THEME_LIST = [
  { name: 'Regular', label: 'Regular' },
  { name: 'ColorBlind', label: 'ColorBlind' }
]

export const Footer = props => {
  const date = new Date()
  return (
    <Row className={css(style.main.wrapper)} tag='footer'>
      <Container>
        <Row className={`${css(style.top.wrapper)}`}>
          <Col className={css(style.top.container)}>
            <Row className={css(style.top.innerWrapper)}>
              <Col
                xs='12'
                lg='3'
                className={`d-flex flex-column align-items-center ${css(
                  style.top.company
                )}`}
              >
                <img
                  src='/images/light-logo.svg'
                  alt='logo'
                  className={css(style.top.logo)}
                />
                <p className={css(style.top.address)}>
                  Very Poor People, LLC. <br />
                  10601 CLARENCE DR STE 250 <br />
                  FRISCO TX 75033-3867 USA
                </p>
                <a
                  href='mailto:support@vppgamingnetwork.com'
                  className={css(style.top.email)}
                >
                  support@vppgamingnetwork.com
                </a>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            <Row>
              {!props.hasOwnProperty('theme') ? (
                <Col xs='12' lg />
              ) : (
                <Col xs='12' lg>
                  <ul className={`d-flex ${css(style.bottom.list)}`}>
                    <li className={css(style.bottom.listItem)}>Theme:</li>
                    {THEME_LIST.map((theme, index) => (
                      <ThemeItem
                        key={index}
                        onClick={props.onThemeClick}
                        activeIndex={props.theme}
                        theme={{ ...theme, index }}
                      />
                    ))}
                  </ul>
                </Col>
              )}
              <Col xs='12' lg='auto'>
                <ul className={`d-flex ${css(style.bottom.list)}`}>
                  <li className={css(style.bottom.listItem)}>
                    <Link
                      to='/privacy'
                      className={css(style.bottom.listItemLink)}
                    >
                      Privacy policy
                    </Link>
                  </li>
                  <li className={css(style.bottom.listItem)}>
                    <Link
                      to='/terms'
                      className={css(style.bottom.listItemLink)}
                    >
                      Terms of use
                    </Link>
                  </li>
                  <li className={css(style.bottom.listItem)}>
                    Copyright &copy; {date.getUTCFullYear()}
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Row>
  )
}

const ThemeItem = props => {
  return (
    <li className={css(style.bottom.listItem)}>
      <span
        onClick={e => props.onClick(props.theme.index)}
        className={css(
          style.bottom.themeItem,
          style.bottom.listItemLink,
          props.activeIndex === props.theme.index
            ? style.bottom.activeTheme
            : null
        )}
      >
        {props.theme.label}
      </span>
    </li>
  )
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/partials/Footer/index.js